import React from 'react'
import VoiceMailGreetingContent from './Ui/Blocks/VoiceMailGreetingContent'

const VoiceMailGreeting = () => {
  return <VoiceMailGreetingContent />
}

export default VoiceMailGreeting
